import { createContext } from "react";

const AccountGroupContext = createContext();

export default AccountGroupContext;
